import { useLocalization } from 'localization/useLocalization';
import React, { useContext, useMemo, useState } from 'react';
import { RecordContext } from 'shared/records/RecordContext';
import { QuickFilter } from '../PaymentsCard';
import { SelectableColumn } from '../SelectableColumn';
import { createColumnRecord } from '../utils/createColumnRecord';
import { createHeaders } from '../utils/createHeaders';
import { createQfRecord } from '../utils/createQfRecord';
import { ViewContext } from './ViewContext';

// enkel hier nodig
const DefaultColumns: SelectableColumn[] = ['paymentDate', 'reference', 'paymentMethodIdentifier', 'salesType', 'amountPaid'];

export const ViewProvider = ({ children }: any) => {
	const { saleTypeRecord } = useContext(RecordContext);
	const strings = useLocalization();
	const [qf, setQf] = useState<QuickFilter>('all');
	const [columns, setColumns] = useState<SelectableColumn[]>(DefaultColumns);
	const colRecord = useMemo(() => createColumnRecord(strings), [strings]);
	const headers = useMemo(() => createHeaders(colRecord, saleTypeRecord, strings), [colRecord, saleTypeRecord, strings]);
	const quickFilterRecord = useMemo(() => createQfRecord(strings), [strings]);

	return (
		<ViewContext.Provider
			value={{
				columns: columns,
				columnsRecord: colRecord,
				headers: headers,
				setColumns: setColumns,
				quickFilter: qf,
				setQuickFilter: setQf,
				quickFilterRecord: quickFilterRecord,
				// exportRecord: exportRecord,
			}}>
			{children}
		</ViewContext.Provider>
	);
};
